<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style lang="scss">
  .el-input__suffix-inner {
     display: flex;
     height: 100%;
     justify-content: center;
     align-items: center;
  }
</style>